<div class="modal-header">
  <h2 class="modal-title">
    {{
      customTitle
        ? (customTitle | translate)
        : (configurationService.supervisorDisplayName$ | async)
    }}

    <i
      class="ms-2 fa fa-question-circle"
      role="button"
      tabindex="0"
      [tooltip]="'memberModule.supervisorsTooltip' | translate"
    ></i>
  </h2>
  <button
    type="button"
    class="btn-close"
    attr.aria-label="{{ 'general.close' | translate }}"
    (click)="cancel()"
  ></button>
</div>
<div
  class="modal-body"
  *ngIf="!(isLoading$ | async) || (memberLoading$ | async)"
>
  <div class="d-flex justify-content-end mx-auto mt-2">
    <div
      class="spinner-border"
      role="status"
      attr.aria-label="{{ 'general.loading' | translate }}"
    >
    </div>
  </div>
</div>
<supervisor-booking-assign-table
  [supervisor]="true"
  (onBulkAction)="onBulkAction($event)"
  [bulkActions]="[BulkAction.ATTACH, BulkAction.INVITE]"
  [booking]="booking$ | async"
  [tableData]="supervisorData$ | async"
  [fecthTags]="false"
  [wantCalculationHours$]="wantCalculationHours$"
  [wantShowSchedule$]="wantShowSchedule$"
  [showCalculationButton]="true"
  [showScheduleButton]="true"
  [showButtonsInsteadBulkActions]="showButtonsInsteadBulkActions"
  [showCancelButtonInModalVersion]="showCancelButtonInModalVersion"
  (onWantShowSchedule)="onWantShowSchedule($event)"
  (onWantCalculationHours)="makeCalculationHours($event)"
  (onRenderTable)="isLoadingRelations = $event"
  (onClickCancelButton)="cancel()"
></supervisor-booking-assign-table>

<div
  *ngIf="displayStyle == 'block'"
  class="processingModal"
  tabindex="-1"
  role="dialog"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div>
        <h2 class="modal-title">
          {{ 'general.processingSerie' | translate }}
        </h2>
      </div>
      <div class="modal-body">
        <ng-container *ngIf="!displayAttachMode">
          <div class="h5 ms-4">
            {{ 'general.totalCalls' | translate }} : {{ totalCalls }}
          </div>
          <div class="h5 ms-4">
            {{ 'general.totalCallsMade' | translate }} : {{ totalCallsMade }}
          </div>
        </ng-container>
        <ng-container *ngIf="displayAttachMode">
          <div class="h5 ms-4">
            {{ 'general.supervisorSelected' | translate }} :
            {{ totalSupervisorSelected }}
          </div>
          <div class="h5 ms-4">
            {{ 'general.supervisorCalculated' | translate }} :
            {{ calculatedSupervisor }}
          </div>
          <div class="h5 ms-4">
            {{ 'general.totalCalls' | translate }} : {{ totalCalls }}
          </div>
          <div class="h5 ms-4">
            {{ 'general.totalCallsMade' | translate }} : {{ totalCallsMade }}
          </div>
        </ng-container>
        <div
          class="d-flex justify-content-center mx-auto mt-2"
          [ngClass]="loadingColor"
        >
          <div
            class="spinner-border"
            role="status"
            attr.aria-label="{{ 'general.loading' | translate }}"
          >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
